import { render } from "./ProfileEstates.vue?vue&type=template&id=70586aff&scoped=true&ts=true&lang=pug"
import script from "./ProfileEstates.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileEstates.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileEstates.vue?vue&type=style&index=0&id=70586aff&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70586aff"]])

export default __exports__